var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nl2br',{attrs:{"text":_vm.text,"tag":"p","class-name":"g-gray-2-text-color g-small-text"}})}
var staticRenderFns = []

export { render, staticRenderFns }